export const getFriendsName = (name) => {
  const arrname = name.split(" ");
  var namepass = "";
  if (arrname.length >= 2) {
    namepass = arrname[0] + " " + arrname[1].charAt(0) + ".";
    return namepass;
  }

  return namepass;
};
export const getBirthdateForDisplay = (birthdate) => {
  var array = birthdate.split("-");
  if (array.length == 3) {
    var month = getSortMonth(array[1]);
    return month + " " + array[2] + ", " + array[0];
  }
  return birthdate;
};

//As per Gautam Suggestion i made change for coupans expiration
export const getStringForCouponExpiration = (coupon) => {
  if (coupon.hasOwnProperty("coupon_expiration")) {
    return coupon.coupon_expiration;
  }

  if (
    coupon.hasOwnProperty("campaign_coupon") &&
    coupon.campaign_coupon.hasOwnProperty("coupon_expiration")
  ) {
    return coupon.campaign_coupon.coupon_expiration;
  }
  if (coupon.hasOwnProperty("expiration_value")) {
    return coupon?.expiration_value;
  }
  if (
    coupon.hasOwnProperty("product") &&
    coupon?.product.hasOwnProperty("coupon") &&
    coupon?.product?.coupon.hasOwnProperty("expiration_value")
  ) {
    return coupon?.product?.coupon?.expiration_value;
  }
  return "";
  // if (coupon && coupon.campaign_coupon) {
  //   if (coupon.campaign_coupon.can_expire == 0) {
  //     return "NEVER EXPIRES";
  //   }
  //   if (
  //     coupon.campaign_coupon.expiration_type &&
  //     coupon.campaign_coupon.expiration_type == "Static_Date"
  //   ) {
  //     if (coupon.campaign_coupon.expiration_date) {
  //       const d = new Date(coupon.campaign_coupon.expiration_date);
  //       if (d > new Date()) {
  //         return (
  //           "Expires on " +
  //           formatExpirationDate(coupon.campaign_coupon.expiration_date)
  //         );
  //       } else {
  //         return "Expired";
  //       }
  //     } else {
  //       return "";
  //     }
  //   } else {
  //     if (
  //       coupon.campaign_coupon.expiration &&
  //       coupon.campaign_coupon.expiration.length > 0 &&
  //       coupon.campaign_coupon.created_at
  //     ) {
  //       const d = new Date(coupon.campaign_coupon.created_at);
  //       d.setDate(d.getDate() + parseInt(coupon.campaign_coupon.expiration));
  //       if (d > new Date()) {
  //         return "Expires On " + formatExpirationDate(d);
  //       } else {
  //         return "Expired";
  //       }
  //     } else {
  //       return "";
  //     }
  //   }
  // } else {
  //   return returnForDashboard(coupon);
  // }
  // return "";
};

function returnForDashboard(coupon) {
  // if (coupon.can_expire == 0) {
  //   return "NEVER EXPIRES";
  // }
  // if (coupon.expiration_type && coupon.expiration_type == "Static_Date") {
  //   if (coupon.expiration_date) {
  //     const d = new Date(coupon.expiration_date);
  //     if (d > new Date()) {
  //       return "Expires on " + formatExpirationDate(coupon.expiration_date);
  //     } else {
  //       return "Expired";
  //     }
  //   } else {
  //     return "";
  //   }
  // } else {
  //   if (
  //     coupon.expiration &&
  //     coupon.expiration.length > 0 &&
  //     coupon.created_at
  //   ) {
  //     const d = new Date(coupon.created_at);
  //     d.setDate(d.getDate() + parseInt(coupon.expiration));
  //     if (d > new Date()) {
  //       return "Expires On " + formatExpirationDate(d);
  //     } else {
  //       return "Expired";
  //     }
  //   } else {
  //     return "";
  //   }
  // }
  // return "";
}

export const getStringForDigitalCouponExpiration = (coupon) => {
  if (coupon.hasOwnProperty("expiration_value")) {
    return coupon.expiration_value;
  }
  return "";
};

function formatExpirationDate(date) {
  return new Date(date).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function getSortMonth(month) {
  var strtoreturn = "";
  switch (parseInt(month)) {
    case 1:
      strtoreturn = "Jan";
      break;
    case 2:
      strtoreturn = "Feb";
      break;
    case 3:
      strtoreturn = "Mar";
      break;
    case 4:
      strtoreturn = "Apr";
      break;
    case 5:
      strtoreturn = "May";
      break;
    case 6:
      strtoreturn = "Jun";
      break;
    case 7:
      strtoreturn = "Jul";
      break;
    case 8:
      strtoreturn = "Aug";
      break;
    case 9:
      strtoreturn = "Sep";
      break;
    case 10:
      strtoreturn = "Oct";
      break;
    case 11:
      strtoreturn = "Nov";
      break;
    case 12:
      strtoreturn = "Dec";
      break;
    default:
      break;
  }
  return strtoreturn;
}

import { useCommonStore } from "src/stores/common-store";
import { useSignUp } from "src/stores/signUp-store";
import { useUserInfo } from "src/stores/user-store";
import { getUserAge } from "./index";
import { Platform } from "quasar";

export async function LookupLNSDBToFindMatchingProfile(email, phone) {
  const useSignUpStore = useSignUp();
  const commonStore = useCommonStore();
  let statusObj = {
    successed: false,
  };
  if (email.length > 0) {
    commonStore.setLoader(true);
    await useSignUpStore
      .verifyAndCheckEmail({
        email: email,
      })
      .then((res) => {
        if (res.status) {
          statusObj.successed = false;
          statusObj.message = res.message;
        } else {
          statusObj = {
            successed: true,
            data: res.data,
            isFtxCoreId: res.isFtxCoreId,
          };
          if (res.is_deleted) {
            statusObj.is_deleted = res.is_deleted;
            statusObj.message = res.message;
          }
        }

        statusObj.coreCustomerId = res.coreCustomerId ? res.coreCustomerId : "";
        statusObj.coreLoginId = res.coreLoginId ? res.coreLoginId : "";
      })
      .finally(() => commonStore.setLoader(false));
  } else if (phone.length > 0) {
    commonStore.setLoader(true);
    await useSignUpStore
      .verifyAndCheckPhone({
        phone: phone,
      })
      .then((res) => {
        if (res.status) {
          statusObj.successed = false;
          statusObj.message = res.message;
        } else {
          statusObj = {
            successed: true,
            isFtxCoreId: res.isFtxCoreId,
          };
          if (res.is_deleted) {
            statusObj.is_deleted = res.is_deleted;
            statusObj.message = res.message;
          }
        }
        statusObj.coreCustomerId = res.coreCustomerId ? res.coreCustomerId : "";
        statusObj.coreLoginId = res.coreLoginId ? res.coreLoginId : "";
      })
      .finally(() => commonStore.setLoader(false));
  }
  return statusObj;
}

export const isUserAVTVerified = () => {
  const userDetails = useUserInfo();
  //Avt Verified changes for white lable lns
  if (!Platform?.is?.cordova && getAccountID()) {
    return true;
  }
  //-----OLD AVT Condition-------//
  // if (
  //   userDetails.user_info?.isDlVerified &&
  //   userDetails.user_info.date_of_birth &&
  //   getUserAge(userDetails.user_info.date_of_birth) >= 21
  // ) {
  //   return true;
  // }
  // return false;
  //-----------------------------//

  //-----NEW AVT Condition-------//
  if (userDetails?.user_info?.avt_verified) {
    if (userDetails?.user_info?.avt_verified == 2) {
      return true;
    } else if (userDetails?.user_info?.avt_verified == 3) {
      return true;
    } else if (
      userDetails?.user_info?.avt_verified == 1 &&
      userDetails?.user_info?.avt_scanned == 1
    ) {
      return true;
    }
  }
  return false;
  //-----------------------------//
};

export const showProgressOnDeal = (deal) => {
  if (deal.trigger_type == "PointsEarned") {
    return true;
  }
  return false;
};

export const kFormatter = (n) => {
  let format;
  if (n < 0) {
    format = "-" + formatCash(-1 * n);
  } else {
    format = formatCash(n);
  }
  return format;
};

function formatCash(n) {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
}

export const getAccountAcr = () => {
  try {
    let accountAcr = useCommonStore()?.storeDetails?.tenant_acr;
    return accountAcr ? `tenant:${accountAcr}` : null;
  } catch (error) {}

  return null;
};

export const getAccountID = () => {
  var accountId = null;
  try {
    const commonStore = useCommonStore();
    if (commonStore.storeDetails?.account_id) {
      accountId = commonStore.storeDetails.account_id;
    }
  } catch (error) {}

  return accountId;
};

export const getCompanyName = () => {
  const commonStore = useCommonStore();
  var tmp = "Loyal-n-Save";
  if (
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("app_name") &&
    commonStore.storeDetails.app_name &&
    commonStore.storeDetails.app_name.length
  ) {
    tmp = commonStore.storeDetails.app_name;
  }
  return tmp;
};

export const getTermContents = () => {
  const commonStore = useCommonStore();
  var tmp = "";

  if (
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("term_contents") &&
    commonStore.storeDetails.term_contents &&
    commonStore.storeDetails.term_contents.length
  ) {
    tmp = commonStore.storeDetails.term_contents;
  }

  return tmp;
};

export const getPrivacyPolicyContents = () => {
  const commonStore = useCommonStore();
  var tmp = "";

  if (
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("privacy_policy_contents") &&
    commonStore.storeDetails.privacy_policy_contents &&
    commonStore.storeDetails.privacy_policy_contents.length
  ) {
    tmp = commonStore.storeDetails.privacy_policy_contents;
  }

  return tmp;
};

export const getContactUsContents = () => {
  const commonStore = useCommonStore();
  var tmp = "";

  if (
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("contact_us_details") &&
    commonStore.storeDetails.contact_us_details &&
    commonStore.storeDetails.contact_us_details.length
  ) {
    tmp = commonStore.storeDetails.contact_us_details;
  }

  return tmp;
};

export const getAccountApplicationID = () => {
  const commonStore = useCommonStore();
  var tmpAccountApplicationID = "";

  if (
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("lns_account_application_id") &&
    commonStore.storeDetails.lns_account_application_id &&
    commonStore.storeDetails.lns_account_application_id.length
  ) {
    tmpAccountApplicationID =
      commonStore.storeDetails.lns_account_application_id;
  } else {
    tmpAccountApplicationID = process.env.LNS_ACCOUNT_APPLICATION_ID;
  }

  return tmpAccountApplicationID;
};

export const getAndroidAppLink = () => {
  const commonStore = useCommonStore();
  var applink = "";

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("app_android_link") &&
    commonStore.storeDetails.app_android_link &&
    commonStore.storeDetails.app_android_link.length
  ) {
    applink = commonStore.storeDetails.app_android_link;
  } else {
    if (!getAccountID()) {
      applink =
        "https://play.google.com/store/apps/details?id=com.loyalnsave.loyalnsave";
    }
  }

  return applink;
};

export const getImageForLoginScreen = () => {
  const commonStore = useCommonStore();
  var web_banner = "";
  if (Platform?.is?.mobile) {
    web_banner = "auth-bg.png";
  } else {
    web_banner = "auth-bg-web.png";
  }
  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("web_banner") &&
    commonStore.storeDetails.web_banner &&
    commonStore.storeDetails.web_banner.length
  ) {
    web_banner = commonStore.storeDetails.web_banner;
  }
  return web_banner;
};

export const getiOSAppLink = () => {
  const commonStore = useCommonStore();
  var applink = "";

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("app_ios_link") &&
    commonStore.storeDetails.app_ios_link &&
    commonStore.storeDetails.app_ios_link.length
  ) {
    applink = commonStore.storeDetails.app_ios_link;
  } else {
    if (!getAccountID()) {
      applink = "https://apps.apple.com/us/app/loyalnsave/id1402024911";
    }
  }

  return applink;
};

export const getSwagShopDisplay = () => {
  const commonStore = useCommonStore();
  var swag_shop = true;
  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("swag_shop")
  ) {
    swag_shop =
      commonStore.storeDetails.pwa_settings.swag_shop == "0" ? false : true;
  }
  return swag_shop;
};

export const getFriendDisplay = () => {
  const commonStore = useCommonStore();
  var friends = true;
  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("friends")
  ) {
    friends =
      commonStore.storeDetails.pwa_settings.friends == "0" ? false : true;
  }
  return friends;
};

export const getLinkLoyaltyDisplay = () => {
  const commonStore = useCommonStore();
  var loyalty_cards = true;
  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("loyalty_cards")
  ) {
    loyalty_cards =
      commonStore.storeDetails.pwa_settings.loyalty_cards == "0" ? false : true;
  }
  return loyalty_cards;
};

export const getLeaderBoardDisplay = () => {
  const commonStore = useCommonStore();
  var leaderboard = true;
  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("leaderboard")
  ) {
    leaderboard =
      commonStore.storeDetails.pwa_settings.leaderboard == "0" ? false : true;
  }
  return leaderboard;
};

export const getStringForTokensOrPoints = () => {
  const commonStore = useCommonStore();
  var reward_keyword = "Tokens";

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("reward_keyword")
  ) {
    reward_keyword = commonStore.storeDetails.reward_keyword;
  }

  reward_keyword =
    reward_keyword.charAt(0).toUpperCase() + reward_keyword.slice(1);

  return reward_keyword;
};

export const getMFGDisplay = () => {
  const commonStore = useCommonStore();
  var mfg = true;

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("mfg")
  ) {
    mfg = commonStore.storeDetails.pwa_settings.mfg == "0" ? false : true;
  }
  return mfg;
};

export const getStoreReviewDisplay = () => {
  const commonStore = useCommonStore();
  var reviews = true;

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("reviews")
  ) {
    reviews =
      commonStore.storeDetails.pwa_settings.reviews == "0" ? false : true;
  }
  return reviews;
};

export const getAppFeedBackDisplay = () => {
  const commonStore = useCommonStore();
  var feedback = true;

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("feedback")
  ) {
    feedback =
      commonStore.storeDetails.pwa_settings.feedback == "0" ? false : true;
  }
  return feedback;
};

export const getBarcodeDisplay = () => {
  const commonStore = useCommonStore();
  var barcode = true;

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("barcode")
  ) {
    barcode =
      commonStore.storeDetails.pwa_settings.barcode == "0" ? false : true;
  }
  return barcode;
};

export const getExternalLinks = () => {
  const commonStore = useCommonStore();
  var external_links = [];

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("external_links")
  ) {
    external_links = commonStore.storeDetails.external_links;
  }
  return external_links ? external_links : [];
};

export const getAppBottomMenu = () => {
  const commonStore = useCommonStore();
  var app_bottom_menu = ["message", "swagshop", "notification"];

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("app_bottom_menu")
  ) {
    app_bottom_menu = commonStore.storeDetails.app_bottom_menu;
  }
  return app_bottom_menu;
};

export const getContactUsDisplay = () => {
  const commonStore = useCommonStore();
  var contact_us = false;

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("contact_us")
  ) {
    contact_us =
      commonStore.storeDetails.pwa_settings.contact_us == "0" ? false : true;
  }
  return contact_us;
};

export const getContactUsContent = () => {
  const commonStore = useCommonStore();
  var contact_us_details = "";

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("contact_us_details")
  ) {
    contact_us_details = commonStore.storeDetails.contact_us_details;
  }
  return contact_us_details;
};

export const getPWABanner = () => {
  const commonStore = useCommonStore();
  var pwa_banner = "";

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_banner")
  ) {
    pwa_banner = commonStore.storeDetails.pwa_banner
      ? commonStore.storeDetails.pwa_banner
      : "";
  }
  return pwa_banner;
};

export const getPWABannerLink = () => {
  const commonStore = useCommonStore();
  var pwa_banner_link = "";

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_banner_link")
  ) {
    pwa_banner_link = commonStore.storeDetails.pwa_banner_link
      ? commonStore.storeDetails.pwa_banner_link
      : "";
  }
  return pwa_banner_link;
};

export const getCouponDisplay = () => {
  const commonStore = useCommonStore();
  var coupons = true;

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("coupons")
  ) {
    coupons =
      commonStore.storeDetails.pwa_settings.coupons == "0" ? false : true;
  }
  return coupons;
};

export const isEAIVEnable = () => {
  const commonStore = useCommonStore();
  var eaiv_enable = true;

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("disable_eaiv")
  ) {
    eaiv_enable = commonStore.storeDetails.disable_eaiv == "0" ? true : false;
  }
  return eaiv_enable;
};

export const getPWABannerToggleDisplay = () => {
  const commonStore = useCommonStore();
  var pwa_banner_toggle = true;

  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("pwa_settings") &&
    commonStore.storeDetails?.pwa_settings?.hasOwnProperty("pwa_banner_toggle")
  ) {
    pwa_banner_toggle =
      commonStore.storeDetails.pwa_settings.pwa_banner_toggle == "0"
        ? false
        : true;
  }
  return pwa_banner_toggle;
};

export const getFirebaseConfigForWhiteLabel = () => {
  const commonStore = useCommonStore();
  var firebase_config = {};
  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("firebase_config") &&
    Object.keys(commonStore?.storeDetails?.firebase_config).length
  ) {
    firebase_config = commonStore.storeDetails.firebase_config;
  }
  return firebase_config;
};

export const getDashboardVersion = () => {
  const commonStore = useCommonStore();
  var version = 1;
  if (
    getAccountID() &&
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("wl_dashboard_type")
  ) {
    version =
      commonStore.storeDetails.wl_dashboard_type == "dashboard-1" ? 1 : 2;
  }
  return version;
};

export const convertBase64ToBlob = (base64Image) => {
  // Split into two parts
  const parts = base64Image.split(";base64,");

  // Hold the content type
  const imageType = parts[0].split(":")[1];

  // Decode Base64 string
  const decodedData = window.atob(parts[1]);

  // Create UNIT8ARRAY of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length);

  // Insert all character code into uInt8Array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  // Return BLOB image after conversion
  return new Blob([uInt8Array], { type: imageType });
};

export function goToHomeScreen(router) {
  // if (getAccountID()) {
  //   router.push({
  //     name: "StoreDetail",
  //     params: { storeid: getAccountID() },
  //   });
  //   return;
  // } else {
  // }

  router.push({ name: "Home" });
}

export function getStringForCombinedOrNot(productDetail) {
  if (
    productDetail.hasOwnProperty("can_combine_with_other") &&
    productDetail.can_combine_with_other == 0
  ) {
    if (
      productDetail.hasOwnProperty("is_custom") &&
      productDetail.is_custom == 1
    ) {
      return "";
    }
    return "This coupon cannot be combined with other coupons.";
  }
  return "";
}

export function getStringForOnceParSale(productDetail) {
  return productDetail.hasOwnProperty("once_per_sale") &&
    productDetail.once_per_sale == 1
    ? "Coupon can only be used once per sale."
    : "";
}
export const getLocalKeyForReminder = (forwhat, storeid, userid) => {
  return storeid + "_" + userid + "_" + forwhat;
};

export function stringToJson(jsonString) {
  return JSON.parse(jsonString);
}

export const getQrScanString = (isFromHomeScreenMobileMarketPlace) => {
  if (isFromHomeScreenMobileMarketPlace) {
    //Market place or normal lns app dashboard for mobile
    //-MarketPlace Mobile Dashboard
    return "Present this code to cashier when making a purchase or to a friend to share your stores";
  } else {
    if (getAccountID()) {
      if (getFriendDisplay()) {
        //If not market place and friend modules enable from single settings
        //-WhiteLabel Web With Friend Module
        //-WhiteLabel Mobile With Friend Module
        return "Present this code to the cashier when making a purchase or to a friend to share this store.";
      } else {
        //If not market place and friend modules disable from single settings
        //-WhiteLabel Web Without Friend Module
        //-WhiteLabel Mobile Without Friend Module
        return "Present this code each time you make a purchase in our stores.";
      }
    } else {
      //Market place mobile and web
      //-MarketPlace Web StoreDetails
      //-MarketPlace Mobile StoreDetails
      return "Present this QR code to the cashier when making a purchase or to a friend to share your store.";
    }
  }
};
